export const routesWithTitles = [
  {
    path: '/',
    title: 'Home Auctions',
  },
  {
    path: '/auction-list',
    title: 'Auction List',
  },
  {
    path: '/posts',
    title: 'Post List',
  },
  {
    path: '/posts/:id',
    title: 'Post Details',
  },
  {
    path: '/auctions/:id',
    title: 'Auction Details',
  },
  {
    path: '/services',
    title: 'Services',
  },
  {
    path: '/profile',
    title: 'My Profile',
  },
  {
    path: '/activity/my',
    title: 'My Activity',
  },
  {
    path: '/favorites',
    title: 'Favorites',
  },
  {
    path: '/login',
    title: 'Login',
  },
  {
    path: '/register',
    title: 'Register',
  },
  {
    path: '/account/verify-email',
    title: 'Verify Email',
  },
  {
    path: '/account/changePassword',
    title: 'Change Password',
  },
  {
    path: '/cancelled/:id',
    title: 'Cancelled',
  },
  {
    path: '/failed/:id',
    title: 'Failed',
  },
  {
    path: '/success/:id',
    title: 'Success',
  },
]
